export function isValidValue(value) {
    try {
        value = value.trim();
        if (value === 'false' || value === 'true') {
            console.log('Invalid value: Boolean represented as string');
            return false;
        }
        const parsedValue = Number(value);
        if (value && value !== 'null' && value !== 'undefined' && value !== '0' && !isNaN(parsedValue) && parsedValue !== 0 && parsedValue !== Infinity && parsedValue !== -Infinity) {
            console.log('Valid value:', parsedValue);
            return true;
        } else {
            console.log('Invalid or missing value');
            return false;
        }
    } catch (error) {
        console.error('Error occurred while checking localStorage value:', error);
        return false;
    }
}
